import {Repository, createRepository} from '@/repositories/Base/Repository'

class StateRepository extends Repository {
    endpoint = 'vns/states'

    fetchAll(params) {
        return this.$axios.get(`${this.endpoint}/table`, {params})
    }

    search(params) {
        return this.$axios.get(`${this.endpoint}/list`, {params})
    }

    fetch(id) {
        return this.$axios.get(`${this.endpoint}/${id}/show`)
    }

    post(params) {
        return this.$axios.post(`${this.endpoint}/post`, params)
    }

    put(id, params) {
        // return this.$axios.put(`${this.endpoint}/${id}`, params)
        return this.$axios.post(`${this.endpoint}/post`, {...params, id: id})
    }
}

export default new StateRepository()

export const create = createRepository(StateRepository)
